import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import HomePage from '@/components/HomePage'
import Login from '@/components/Login'
import Client from '@/components/Client'
import Email from '@/components/email/Email'
import EmailEdit from '@/components/email/EmailEdit'
import EmailPrev from '@/components/email/EmailPrev'
import Contact from '@/components/contact/Contact'
import Config from '@/components/config/Config'
import Task from '@/components/task/Task'
import success from '@/components/success'
import CpGroup from '@/components/cp/CpGroup'
import Cp from '@/components/cp/Cp'
import Outboxs from "../components/outboxs/Outboxs.vue";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      children:[
        {path:'/homepage',name:'HomePage',component:HomePage},
        {path:'/client',name:'Client',component:Client},
        {path:'/email',name:'Email',component:Email},
        {path:'/emailedit',name:'EmailEdit',component:EmailEdit},
        {path:'/emailprev',name:'EmailPrev',component:EmailPrev},
        {path:'/contact',name:'Contact',component:Contact},
        {path:'/config',name:'Config',component:Config},
        {path:'/task',name:'Task',component:Task},
        {path:'/success',name:'success',component:success},
        {path:'/cpgroup',name:'CpGroup',component:CpGroup},
        {path:'/cp',name:'Cp',component:Cp},
        {path:'/Outboxs',name:'Outboxs',component:Outboxs},
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js